import { gql } from "graphql-request";

const SERVER_GET_BUSINESESS = gql`
  {
    businesses {
      id
      name
    }
  }
`

export default SERVER_GET_BUSINESESS;
